import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../../../Containers/Config/index.js';
import apiCall from '../../../../../apiCall.js';
import { GET_DASHBOARD_CONFIGS, GET_DASHBOARD_CONFIGS_ERROR, GET_DASHBOARD_CONFIGS_SUCCESS } from '../../../../../actionType.js';

// GET /api/v1/dashboard-configs?side_bar_config_key=… — saved canvas
// layouts for a sidebar section, used to hydrate the viewer/builder.
function* getDashboardConfigs({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/dashboard-configs`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.params,
    });

    if (response.status === 200) {
      yield put({
        type: GET_DASHBOARD_CONFIGS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_DASHBOARD_CONFIGS_ERROR,
        payload: response?.response?.data?.message || response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_DASHBOARD_CONFIGS_ERROR, payload: error });
  }
}

export function* watchGetDashboardConfigs() {
  yield takeEvery(GET_DASHBOARD_CONFIGS, getDashboardConfigs);
}

function* getDashboardConfigsSaga() {
  yield all([fork(watchGetDashboardConfigs)]);
}

export default getDashboardConfigsSaga;
